"use strict";
export default (...parameters) => {
  if (parameters.length === 2) {
    const [model, actionName] = parameters;
    const fullActionName = model.name + "." + actionName;
    model.actions[actionName] = fullActionName;
    return fullActionName;
  } else if (parameters.length === 1) {
    return parameters[0];
  } else {
    throw "Unexpected arguments. Action expects either 1 or 2 arguments but received " + parameters.length;
  }
};
